module.exports = __webpack_public_path__ + "static/media/ne.fb79db2c.jpeg";